import React from 'react'
import { Button } from 'antd'
import { motion, Variants } from 'framer-motion'
import styles from './Title.module.scss'

interface Props {
  title: string
  actionText?: string
  onAction?: () => void
  titleActions?: React.ReactNode
  extraActions?: React.ReactNode
}

export const PageTitle = ({ title, actionText, onAction, titleActions, extraActions }: Props) => {
  const showActions = !!(actionText && onAction) || !!extraActions

  return (
    <div className={styles.root}>
      <motion.div
        className={styles.left}
        variants={varsTitle}
        initial={'init'}
        animate={'enter'}
      >
        <h1 className={styles.heading}>
          {title}
        </h1>
        {titleActions}
      </motion.div>
      {showActions && (
        <motion.div
          className={styles.right}
          variants={varsActions}
          initial={'init'}
          animate={'enter'}
        >
          {actionText && onAction && <Button type="primary" onClick={onAction}>{actionText}</Button>}
          {extraActions}
        </motion.div>
      )}
    </div>
  )
}

const varsTitle: Variants = {
  init:  { opacity: 0, x: 20 },
  enter: { opacity: 1, x: 0, transition: { duration: 0.8, ease: 'easeOut' } },
}

const varsActions: Variants = {
  init:  { opacity: 0 },
  enter: { opacity: 1, transition: { delay: 0.2, duration: 0.6, ease: 'easeOut' } },
}
